import { Grid, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { formDatePastDateValidation } from "../../../../app/common";
import DateRangeControl from "../../../../common/components/functional/dateRangeControl/DateRangeControl";

type Props = {
  start: Date | null;
  end: Date | null;
  allowOngoingToggle?: boolean;
};

const DateControl = ({ start, end, allowOngoingToggle = true }: Props) => {
  const { t } = useTranslation();
  const { control, trigger, watch } = useFormContext();

  const endDateValue = watch("endDate");

  const [workRelationshipOngoing, setWorkRelationshipOngoing] = useState(!end);

  useEffect(() => {
    setWorkRelationshipOngoing(!!!endDateValue);
  }, [endDateValue]);

  return (
    <>
      <DateRangeControl
        startKey="startDate"
        endKey="endDate"
        edit
        customLabel={t("workHistory:date")}
        customValidation={formDatePastDateValidation}
      />
      {allowOngoingToggle && (
        <>
          <Grid item xs={3} />
          <Grid
            item
            container
            xs={9}
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item container alignItems="center">
              <Controller
                control={control}
                name="endDate"
                render={({ field }) => (
                  <>
                    <Checkbox
                      sx={{
                        "&.MuiCheckbox-root": {
                          paddingLeft: "0px",
                        },
                      }}
                      checked={workRelationshipOngoing}
                      onChange={(_, checked) => {
                        if (checked) {
                          field.onChange(null);
                          trigger();
                        } else {
                          field.onChange(end);
                        }
                        setWorkRelationshipOngoing(checked);
                      }}
                    />
                    <Typography>{t("workHistory:ongoingRelationship")}</Typography>
                  </>
                )}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default DateControl;
